module.exports = __webpack_public_path__ + "img/homeApp.5ee9f638.png";